module.exports = __webpack_public_path__ + "static/media/plane.68996ca4.svg";